import React  from "react";
import { Query, Loading} from "../../components";
import TestDescription from "../../components/TestDescription/TestDescription";
import TestResults from "./TestResults";
import { getLiveTestSubmittedAnswers } from "../../lib/api";

const Test = ({
  match: {
    params: { tid, qid }
  }
}) => {
  return (
    <>
      <Query query={() => getLiveTestSubmittedAnswers(tid)}>
        {({ loading, data }) => {
          if (loading) {
            return <Loading />;
          }
          return !qid ? (
            <TestDescription {...data} {...{ tid }} results />
          ) : (
            <TestResults {...data} {...{ tid, qid }} />
          );
        }}
      </Query>
    </>
  );
};

export default Test;
